import React from 'react';
import PropTypes from 'prop-types';
import { formatMoney } from '../../../shared/fund/format';

export default function FundSizeInfo({ fund }) {
  const { fundSize, fundSizeDate } = fund;

  const money = formatMoney(fundSize);
  const moneyDate = fundSizeDate ? `(${fundSizeDate})` : null;

  return (
    <>
      {money}
      <small>{moneyDate}</small>
    </>
  );
}

FundSizeInfo.propTypes = {
  fund: PropTypes.shape({
    fundSize: PropTypes.number,
    fundSizeDate: PropTypes.string,
  }).isRequired,
};
